export default (preTag, data) => ({
  data: {
    ...data,
    toExport: true,
    rating: 0,
    maxRating: 5,
  },
  object: 'block',
  type: `${preTag}_title`,
  nodes: [
    {
      object: 'text',
      leaves: [
        {
          text: '',
        },
      ],
    },
  ],
});
